function clone(value) {
  return JSON.parse(JSON.stringify(value))
}


function mergeContent(defaultValue, remoteValue) {
  if (Array.isArray(defaultValue)) {
    if (!Array.isArray(remoteValue)) return defaultValue
    if (!defaultValue.length) return clone(remoteValue)
    const mergedItems = defaultValue.map((defaultItem, index) => {
      return remoteValue[index] === undefined ? defaultItem : mergeContent(defaultItem, remoteValue[index])
    })
    return mergedItems.concat(remoteValue.slice(defaultValue.length).map(clone))
  }
  if (defaultValue && typeof defaultValue === 'object') {
    const result = { ...defaultValue }
    if (!remoteValue || typeof remoteValue !== 'object' || Array.isArray(remoteValue)) return result
    Object.keys(remoteValue).forEach(key => {
      result[key] = defaultValue[key] === undefined ? remoteValue[key] : mergeContent(defaultValue[key], remoteValue[key])
    })
    return result
  }
  if (typeof defaultValue === 'string' && defaultValue && remoteValue === '') return defaultValue
  return remoteValue === undefined ? defaultValue : remoteValue
}

function normalizeSections(sections = []) {
  return sections.map(section => ({
    key: section.key,
    content: clone(section.content || {})
  }))
}

function normalizePage(page = {}) {
  const normalizedPage = clone(page)
  normalizedPage.sections = normalizeSections(page.sections || [])
  return normalizedPage
}

function mergePage(defaultPage, remotePage) {
  const mergedPage = mergeContent(defaultPage, remotePage)
  const defaultSections = defaultPage.sections || []
  const remoteSections = remotePage.sections || []
  const mergedSections = defaultSections.map(section => {
    const remoteSection = remoteSections.find(item => item.key === section.key)
    return remoteSection ? { ...section, content: mergeContent(section.content, remoteSection.content) } : section
  })
  const defaultSectionKeys = new Set(mergedSections.map(section => section.key))
  remoteSections.forEach(section => {
    if (!section.key || defaultSectionKeys.has(section.key)) return
    mergedSections.push(section)
  })
  mergedPage.sections = mergedSections
  return mergedPage
}

export function extractDataTemplate(db) {
  return {
    version: db.version,
    languages: db.languages || ['ua', 'ru', 'en'],
    categories: clone(db.categories || {}),
    general: {
      sections: normalizeSections(((db.general || {}).sections) || [])
    },
    pages: Object.fromEntries(Object.entries(db.pages || {}).map(([pageKey, page]) => [
      pageKey,
      normalizePage(page)
    ])),
    collections: Object.fromEntries(Object.entries(db.collections || {}).map(([collectionKey, collection]) => [
      collectionKey,
      {
        items: clone(collection.items || [])
      }
    ]))
  }
}

export function mergeRemoteDataWithTemplate(defaultData, remoteData) {
  if (!remoteData) return defaultData

  const merged = clone(defaultData)
  merged.categories = {
    ...(defaultData.categories || {}),
    ...((remoteData && remoteData.categories) || {})
  }

  merged.general.sections = (defaultData.general.sections || []).map(section => {
    const remoteSection = ((remoteData.general || {}).sections || []).find(item => item.key === section.key)
    return remoteSection ? { ...section, content: mergeContent(section.content, remoteSection.content) } : section
  })

  Object.keys(defaultData.pages || {}).forEach(pageKey => {
    const remotePage = remoteData.pages && remoteData.pages[pageKey]
    if (!remotePage) return
    merged.pages[pageKey] = mergePage(defaultData.pages[pageKey], remotePage)
  })

  Object.keys(defaultData.collections || {}).forEach(collectionKey => {
    const remoteCollection = remoteData.collections && remoteData.collections[collectionKey]
    if (!remoteCollection || !Array.isArray(remoteCollection.items)) return
    merged.collections[collectionKey].items = remoteCollection.items
  })

  return merged
}
